import { render, staticRenderFns } from "./commisDetails.vue?vue&type=template&id=261c61fb&scoped=true&"
import script from "./commisDetails.vue?vue&type=script&lang=js&"
export * from "./commisDetails.vue?vue&type=script&lang=js&"
import style0 from "./commisDetails.vue?vue&type=style&index=0&id=261c61fb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "261c61fb",
  null
  
)

export default component.exports